import {styled} from "@mui/material/styles";
import Tabs from "@mui/material/Tabs";
import {COLD_PURPLE} from "../../../theme/colors";

export const StyledTabs = styled(Tabs)({
  "& .MuiTabs-indicator": {
    backgroundColor: COLD_PURPLE,
  },
});
